"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gradients = exports.greys = exports.mainColors = exports.brandColors = void 0;
exports.brandColors = {
    brandTurquoise: "#36afc5",
    brandOrange: "#f07d00",
    brandPink: "#e5006a",
    brandGreen: "#a3cf62",
};
exports.mainColors = {
    primaryLight: "#437edb",
    primary: "#245cb4",
    offBlack: "#1d202b",
    jagexBlack: "#1a1b22",
    secondary: "#212537",
    secondaryLight: "#6b7397",
    digitalBlue: "#3aa2ee",
    backgroundBlue: "#202730",
    white: "#ffffff",
    warningRed: "#d93c3c",
    cookieBannerDarkGrey: "#080f1e",
    blueishBlack: "#161E28",
};
exports.greys = {
    grey1000: "#29313B",
    grey900: "#2d3145",
    grey800: "#404252",
    grey700: "#525361",
    grey600: "#63646f",
    grey500: "#75757d",
    grey400: "#86868c",
    grey300: "#96969b",
    grey200: "#a7a7aa",
    grey100: "#b7b7b9",
    grey050: "#c7c7c8",
    grey010: "#d7d7d7",
};
exports.gradients = {
    lightToDark: "linear-gradient(180deg, " + exports.mainColors.primaryLight + ", " + exports.mainColors.primary + ")",
    darkerLeft: "linear-gradient(270.08deg, rgba(34, 35, 39, 0) 22.95%, " + exports.mainColors.offBlack + " 73.93%)",
    darkCorners: "linear-gradient(223.74deg, " + exports.mainColors.backgroundBlue + " 2.51%, rgba(32, 39, 48, 0) 32.93%), linear-gradient(46deg, " + exports.mainColors.backgroundBlue + " 27.7%, rgba(32, 39, 48, 0) 60.45%), linear-gradient(0deg, rgba(32, 39, 48, 0.28), rgba(32, 39, 48, 0.28))",
    shadedCorner: "linear-gradient(46deg, " + exports.mainColors.backgroundBlue + " 9.44%, rgba(32, 39, 48, 0) 60.45%), linear-gradient(0deg, rgba(32, 39, 48, 0.28), rgba(32, 39, 48, 0.28))",
};
var allColors = __assign(__assign(__assign({}, exports.brandColors), exports.mainColors), exports.greys);
exports.default = allColors;
